import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
import CopierMixin from '@/helpers/vue_mixins/v2/CopierMixin';
let ProductReferralMixin = class ProductReferralMixin extends Mixins(CopierMixin) {
    get routeParams() {
        return this.$route.params;
    }
    adsPostbackPayload(uuid) {
        const ads_identifier = 'CG_MINI_APP_PRODUCT_ADS';
        const { appUUID, key } = this.routeParams;
        const service_bundle = key === Bundle.Shopify ? 'SHOPIFY' : 'ECOMMERCE';
        return `${ads_identifier}:${appUUID}:${uuid}:${service_bundle}`;
    }
    originalUrl(image) {
        return image?.galleryBlob?.originalUrl;
    }
    buildReferralLinks(salesChannels, uuid) {
        const { appUUID } = this.routeParams;
        const { activePage, gcashAppId, instagramUsername } = salesChannels;
        return this.buildReferralLink(this.buildMessengerReferralLink(activePage, uuid, appUUID), this.buildInstagramReferralLink(instagramUsername, uuid, appUUID), this.buildGlifeReferralLink(gcashAppId, uuid), 'referralLink');
    }
    buildMessengerReferralLink(activePage, uuid, appUUID) {
        if (activePage?.fbPageId == null) {
            return null;
        }
        return `https://m.me/${activePage?.fbPageId}?ref=CG_MINI_APP_FB_SHOP:${appUUID}:${uuid}`;
    }
    buildInstagramReferralLink(instagramUsername, uuid, appUUID) {
        if (instagramUsername == null) {
            return null;
        }
        return `https://ig.me/m/${instagramUsername}?ref=CG_MINI_APP_FB_SHOP:${appUUID}:${uuid}`;
    }
    buildGlifeReferralLink(gcashAppId, uuid) {
        if (gcashAppId == null) {
            return null;
        }
        return `https://gcashapp.page.link/?link=https%3A%2F%2Fgcash.splashscreen%2F%3Fredirect%3Dgcash%253A%252F%252Fcom.mynt.gcash%252Fapp%252F006300121300%253FappId%253D${gcashAppId}%2526page%253Dpages%252Fauth%252Fauth%253FproductUuid%253D${uuid}&apn=com.globe.gcash.android&isi=520020791&ibi=com.globetel.gcash`;
    }
};
ProductReferralMixin = __decorate([
    Component
], ProductReferralMixin);
export default ProductReferralMixin;
